function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import './submissionType.scss';
import MobileLogo from "../../assets/images/mobile.svg";
import Check from "../../assets/images/check.svg";
import Hand from "../../assets/images/hand_submission.svg";
import Vector from "../../assets/images/vector.svg";
var mapSubmissionTypes = {
  "online_submission": 1,
  "paper_submission": 2
};
var SubmissionType = function SubmissionType(_ref) {
  var register = _ref.register,
    submissionType = _ref.submissionType;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    submissionTypeNumber = _useState2[0],
    setSubmissionTypeNumber = _useState2[1];
  var onOnlineSubmissionTypeClick = function onOnlineSubmissionTypeClick() {
    return setSubmissionTypeNumber(1);
  };
  var onPaperSubmissionTypeClick = function onPaperSubmissionTypeClick() {
    return setSubmissionTypeNumber(2);
  };
  useEffect(function () {
    setSubmissionTypeNumber(mapSubmissionTypes[submissionType]);
  }, [submissionType]);
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-size-17 font-weight-600 mb-3"
  }, "How do you want students to submit their work?")), /*#__PURE__*/React.createElement("div", {
    className: "text-muted mb-3 mt-2"
  }, "Students can submit digitally through Nurture in both cases."), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "btn ".concat(submissionTypeNumber === 1 ? "border-primary highlight" : " border", " submission-type-option"),
    onClick: onOnlineSubmissionTypeClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "position-absolute right-align mt-3"
  }, /*#__PURE__*/React.createElement("input", Object.assign({}, register("submission_type"), {
    value: 'online_submission',
    type: "radio",
    className: "form-check-input active",
    "aria-label": "Radio button for following text input"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-md-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2 my-auto"
  }, /*#__PURE__*/React.createElement("img", {
    src: MobileLogo,
    alt: "Mobile Logo",
    className: "img-fluid",
    width: "80",
    height: "80"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex mb-2"
  }, /*#__PURE__*/React.createElement("h5", null, "Submit online through Nurture")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("img", {
    src: Check,
    alt: "Check",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("div", {
    className: "point-size text-muted mb-2 ms-1 text-start"
  }, "Students have to upload an attachment of their work and give you their confidence score.")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("img", {
    src: Check,
    alt: "Check",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("div", {
    className: "point-size text-muted mb-2 ms-1 text-start"
  }, "Student work is available to go back over Nurture anytime.")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("img", {
    src: Check,
    alt: "Check",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("div", {
    className: "point-size text-muted mb-2 ms-1 text-start"
  }, "Students reflect on their feedback to unlock their grade.")))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    className: "btn ".concat(submissionTypeNumber === 2 ? "border-primary highlight" : "border", " submission-type-option"),
    onClick: onPaperSubmissionTypeClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "position-absolute right-align mt-3"
  }, /*#__PURE__*/React.createElement("input", Object.assign({}, register("submission_type"), {
    value: 'paper_submission',
    type: "radio",
    className: "form-check-input",
    "aria-label": "Radio button for following text input"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-md-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2 my-auto"
  }, /*#__PURE__*/React.createElement("img", {
    src: Hand,
    alt: "Hand Submission",
    className: "img-fluid",
    width: "80",
    height: "80"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex mb-2"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-start"
  }, "Allow paper submission or online through Nurture")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-1"
  }, /*#__PURE__*/React.createElement("img", {
    src: Vector,
    alt: "Vector",
    width: "17",
    height: "17"
  })), /*#__PURE__*/React.createElement("div", {
    className: "point-size text-muted text-start"
  }, "Students only have to give you their confidence score and a comment if they want to.")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-1"
  }, /*#__PURE__*/React.createElement("img", {
    src: Vector,
    alt: "Vector",
    width: "17",
    height: "17"
  })), /*#__PURE__*/React.createElement("div", {
    className: "point-size text-muted text-start"
  }, "Work may not be available in Nurture if they submit a paper copy.")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center mb-2"
  }, /*#__PURE__*/React.createElement("img", {
    src: Check,
    alt: "Check",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("div", {
    className: "point-size text-muted ms-1 text-start"
  }, "Students reflect on their feedback to unlock their grade.")))))));
};
SubmissionType.defaultProps = {
  submissionType: 'online_submission'
};
export default SubmissionType;